function getThousandsSeparator() {
    if (typeof window.thousandsSeparator != 'undefined') {
        return window.thousandsSeparator;
    }
    return '.';
}

export function priceFormat(x, forcePrecision = 0) {
    if (typeof x != 'undefined') {
        x = parseFloat(x);
        if (!isNaN(x)) {
            let s = x.toString();
            if (x % 1 > 0 || forcePrecision) {
                s = x.toFixed(2);
            } else {
                s = x.toFixed(0);
            }
            return s.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, getThousandsSeparator());
        }
    }
    return "";
}